export enum AchResponseType {
  SUBMITTED = 'submitted',
  RETURN = 'return',
  CHANGE_REQUEST = 'change_request',
  PROCESSED = 'processed',
}

export enum AchStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  APPLIED = 'applied',
  RETURNED = 'returned',
  CANCELED = 'canceled',
}

export enum AchType {
  EXTERNAL = 'external',
  KICKFIN = 'kickfin',
}

export enum AchPaymentType {
  DEBIT = 'debit',
  CREDIT = 'credit',
}

export enum AchMethod {
  AUTO = 'auto',
  MANUAL = 'manual',
}

export interface IAchResponse {
  type: AchResponseType;
  code: string;
  date: string;
  desc: string;
  info?: string;
}

export interface IAchTransaction {
  achResponse?: IAchResponse;
  achType: AchType;
  amount: number;
  bankAccountNumberLast4: string;
  description?: string;
  estimatedSettlementAt: string;
  id: string;
  ledger: string;
  method?: AchMethod;
  paymentType: AchPaymentType;
  statementDesc?: string;
  status: AchStatus;
  transactionType: string;
  createdAt: string;
  updatedAt: string;
}
